import { getGenericEndpoint } from './get.api';
import type { GetAssetsPlayersImagesResponse } from './types';

export const getAssetsPlayersImages = async (lang?: string) => {
	return await getGenericEndpoint<GetAssetsPlayersImagesResponse>(
		'assets/background-images',
		lang,
		false
	);
};
